import React from "react";
import DictionarySettingTable from "./DictionarySettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showDictionarySetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function DictionarySettingPage() {
  const dispatch = useDispatch();
  const { dictionarySetting } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showDictionarySetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>DictionarySetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>DictionarySetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <DictionarySettingTable dataSource={dictionarySetting} />
        </div>
      </div>
    </>
  );
}
